var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternalNoteBadgeLinesPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1a2744",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    d: "M2 4.5h7M2 7h5.5M2 9.5h4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1a2744",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.8 11.2l3.4-3.4.45 1.35-2.4 2.4-1.35-.45z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1a2744",
    strokeWidth: 1,
    strokeLinecap: "round",
    d: "M12.2 8.8l1 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalNoteBadgeLinesPencil);
export default __webpack_public_path__ + "static/media/internal-note-badge-lines-pencil.5d33661c5eedd0f4efc46f43b9a80c2f.svg";
export { ForwardRef as ReactComponent };